import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@mui/material/TextField';
import { Button, DialogActions, FormControl, FormHelperText } from "@material-ui/core";
import {
  voidInvoice
} from "./../../dashboard/actions/dashboardAction";
import InfoIcon from '@mui/icons-material/Info';
import { trim } from "lodash";
import { showErrorToast, showSuccessToast } from "../../../../common/components/Helper/Utils";

const buildVoidPayload = (invoice, reason) => ({
  invoiceId: invoice.id,
  userId: invoice.userid,
  reason: trim(reason),
  serialNo: invoice.serialno,
  productId: invoice?.invoiceproductdetails?.product
    ? invoice?.invoiceproductdetails?.product[0]?.productid
    : null,
});

const buildBulkVoidPayload = (invoices, reason) => ({
  invoiceId: invoices.map((item) => item.id),
  reason: trim(reason),
});

export default function CancelInvoiceModal(props) {
  const { open, handleClose, invoice, invoices, getInvoices, onVoidComplete } = props;
  const invoiceList = invoices?.length ? invoices : invoice ? [invoice] : [];
  const isBulk = invoices?.length > 0;
  const [reason, setReason] = useState('');
  const [errorText, setErrorText] = useState('');
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (open) {
      setReason('');
      setErrorText('');
      setDisabled(false);
    }
  }, [open]);

  const handleVoidSuccess = () => {
    handleClose(true);
    getInvoices(null, 1, false);
    onVoidComplete?.();
    setDisabled(false);
  };

  const updateInvoiceDetails = () => {
    if (reason.length >= 1000) {
      setErrorText('Reason cannot exceed 1000 characters.');
      return;
    }
    if (trim(reason) === '') {
      setErrorText('Void reason should not be blank.');
      return;
    }

    setDisabled(true);
    const trimmedReason = trim(reason);
    const data = isBulk
      ? buildBulkVoidPayload(invoiceList, trimmedReason)
      : buildVoidPayload(invoice, trimmedReason);

    voidInvoice(data, (err, results) => {
      setDisabled(false);
      if (err) {
        showErrorToast(err);
        return;
      }
      if (results?.success === 0) {
        showErrorToast(results?.message || 'Failed to void invoice(s)');
        return;
      }
      if (isBulk && results?.message) {
        showSuccessToast(results.message);
      }
      handleVoidSuccess();
    });
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={'sm'}

    >
      <DialogTitle >
        {isBulk ? `Void ${invoiceList.length} ${invoiceList.length > 1 ? "Invoices" : "Invoice"}` : 'Void Invoice'}
        <IconButton onClick={() => { handleClose(); }} style={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
      <div
        style={{
          fontSize: "16px",
          lineHeight: 1.6,
        }}
      >
        {isBulk ? (
          <>
            Are you sure you want to <strong>Void</strong>{" "}
            <strong>{invoiceList.length}</strong> selected invoice
            {invoiceList.length > 1 ? "s" : ""}?
          </>
        ) : (
          <>
            Are you sure you want to <strong>Void</strong> the invoice?
          </>
        )}
      </div>
              <div><FormControl style={{ width: '400px', margin: '20px 0px' }}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Please enter the reason for void"
                    multiline
                    maxRows={4}
                    required={true}
                    value={reason}
                    style={{ width: '400px !important' }}
                    onChange={(e) => { setReason(e.target.value); setErrorText(''); }}
                  />
                  <FormHelperText className="error-o">{errorText}</FormHelperText>

                </FormControl></div>
                <p
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: '14px',   
          fontWeight: 500,   
          lineHeight: 1.5,
        }}
      >
        <InfoIcon
          style={{
            marginRight: '8px',
            fontSize: '22px',
            color: 'rgba(0, 0, 0, 0.6)',
          }}
        />
        After the void operation, the inventory items are moved to the Unsold state.
      </p>
      </DialogContent>
      <DialogActions>
        <Button color="primary" autoFocus onClick={handleClose}>
          Cancel
        </Button>
        <Button color="primary" disabled={disabled} onClick={updateInvoiceDetails}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}
